
import React, { Component } from 'react';

import Layout from 'components/Dashboard/Layout';
import { ListProvider } from 'core/ListProvider';
import OrderListTable from 'components/Order/ListTable';
import OrderDetail from 'components/Order/Detail';
import PlanningListHeader from './ListHeader';
import { Drawer } from 'ui/Drawer';


export default class PlanningList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isFilterDrawerOpen: false,
    };
  }

  componentDidMount() {
    document.title = 'Планирование';
  }

  getPreviewId = () => {
    const match = this.props.location.pathname.match(/\/preview\/(\d+)/);
    return match ? match[1] : undefined;
  };

  openPreview = (item) => {
    this.props.history.push(`/planning/preview/${item.id}`);
  };

  closePreview = () => {
    this.props.history.push('/planning');
  };

  toggleFilterDrawer = () => {
    this.setState({
      isFilterDrawerOpen: !this.state.isFilterDrawerOpen,
    });
  };

  render() {
    const previewId = this.getPreviewId();
    const listPath = '/planning';

    return (
      <ListProvider
        url={'planning'}
        filterInitial={{
          page_size: 15
        }}
        storageKey={'ListProvider-planning-table-view'}
      >
        <Layout rows={'auto 1fr'}>
          <PlanningListHeader
            view={'general'}
            history={this.props.history}
            onFiltersClick={this.toggleFilterDrawer}
          />

          <OrderListTable
            isFilterDrawerOpen={this.state.isFilterDrawerOpen}
            onCloseFilters={this.toggleFilterDrawer}
            apiUrl={'planning'}
            basePath={'/planning'}
            previewId={previewId}
            listPath={listPath}
            onPreview={this.openPreview}
            onClosePreview={this.closePreview}
          />

          <Drawer
            open={!!previewId}
            onClose={this.closePreview}
            width={'450px'}
            disableEscapeKeyDown={true}
          >
            <OrderDetail
              id={previewId}
              onClose={this.closePreview}
              apiUrl={'planning'}
              basePath={'/planning'}
              fromPath={`${listPath}/preview/${previewId}`}
            />
          </Drawer>
        </Layout>
      </ListProvider>
    );
  }
}
